module.exports = __webpack_public_path__ + "static/depoimento13-c1946fad3399592d679c049650ff4901.png";